export default "__VITE_ASSET__Bw$3ZP1i__"